import React from 'react';
import { render } from 'react-dom';
import SearchBoxController from './src/components/SearchBoxController/SearchBoxController';
import SearchBox from './src/components/SearchBox/SearchBox';
import { getParams } from './src/components/common/utils';
import qs from 'qs';
import './src/components/themes/bootstrap_sbox.css';

if (!global._babelPolyfill && !window._babelPolyfill) { // as per https://github.com/babel/babel/issues/4019 (no duplicate babel-polyfill)
    require("babel-polyfill");
} else {
    // eslint-disable-next-line no-console
    console.warn('"babel-polyfill" already loaded, we skipped the loading. for more info see https://github.com/babel/babel/issues/4019');
}

const renderSearchBoxController = (props) => {
    return (
        props.serverUrl ? <SearchBoxController {...props} /> : <SearchBox />
    );
}

const root = document.getElementById('sbox');
const serverUrl = root.getAttribute('data-url');

/* get the url params as object */
const paramsOnlyString = serverUrl.substring(serverUrl.indexOf('?') + 1, serverUrl.length); // grab everything after the "?"
const paramsAsObject = qs.parse(paramsOnlyString, { ignoreQueryPrefix: true, allowDots: true });
//const paramsAsObject = getParams(paramsOnlyString); // convert to an object
const { roomCategory, results_roomCategory, ...modifiedParams } = paramsAsObject; // change roomCategory parama name to results_roomCategory (api changed, we dont want breaking changes for current clients 26-03-2018)
modifiedParams.results_roomCategory = results_roomCategory || roomCategory;
const props = {
    serverUrl,
    queryStringObj: modifiedParams
};

render(renderSearchBoxController(props), root);



// WEBPACK FOOTER //
// ./index.js